module.exports = __webpack_public_path__ + "img/visa.62a953d9.svg";